import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Navbar from "../../../../globals/components/Navbar";
import {
  DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE,
  isDuplicateAccountsMergeUiEnabled,
} from "../../../../globals/utils/duplicateAccountsMergeFeature";
import DuplicateAccountsHome from "./DuplicateAccountsHome";

/**
 * Shell route for duplicate-account merge. When the gate is off, deep links
 * still resolve here with a client-friendly “not yet available” message.
 */
const DuplicateAccountsMergePage = () => {
  const enabled = isDuplicateAccountsMergeUiEnabled();

  if (enabled) {
    return <DuplicateAccountsHome />;
  }

  return (
    <>
      <Navbar />
      <Box sx={{ p: 4, maxWidth: 720, mx: "auto" }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "action.hover",
            opacity: 0.92,
          }}
        >
          <Typography variant="h5" fontWeight={700} color="text.secondary" gutterBottom>
            Duplicate Accounts
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mt: 1 }}>
            {DUPLICATE_ACCOUNTS_MERGE_LOCKED_USER_MESSAGE}
          </Typography>
        </Paper>
      </Box>
    </>
  );
};

export default DuplicateAccountsMergePage;
